'use strict';
/* global jQuery Vue Inputmask */
/* eslint consistent-this: ["error", "self"] */

(function ($) {

    var popup;


    function hide_popup_node(node) {
        $(node).animate({opacity: 0}, 250, function () {
            node.style.display = 'none';
        });
    }


    function PopupBox(back, front) {
        var self = this;
        self.show = function () {
            back.style.display = 'block';
            back.style.opacity = '0';

            front.style.display = 'block';
            front.style.opacity = '0';

            $(front).animate({opacity: 1}, 250);
            $(back).animate({opacity: 0.7}, 250);

            self.center();
            // front.style.top = window.pageYOffset + 20 + 'px';
        };

        self.hide = function () {
            hide_popup_node(back);
            hide_popup_node(front);
        };

        self.center = function () {
            front.style.top = window.pageYOffset + 20 + 'px';
        };
    }



    function show_promo_addresses_popup(event) {
        event.preventDefault();
        popup.show();
    }



    document.addEventListener('DOMContentLoaded', function () {
        var link_form = document.querySelector('.link_addresses');

        if (document.getElementById('popup_promo_addresses_block')) {
            var close_button = document.getElementById('close_promo_addresses_popup_button');
            var close_button1 = document.getElementById('shadow_promo_addresses_box');

            popup = new PopupBox(
                    document.getElementById('shadow_promo_addresses_box'),
                    document.getElementById('popup_promo_addresses_block')
                    );
            close_button.addEventListener('click', popup.hide);
            close_button1.addEventListener('click', popup.hide);
        }

        if (link_form) {
            link_form.addEventListener('click', show_promo_addresses_popup);
        }


    });

//    document.addEventListener('click', function (ev) {
//
//        var node = ev.target;
//        if (node.classList.contains('link_addresses')) {
//            //ev.preventDefault();
//            show_promo_addresses_popup(ev);
//        }
//    });
}(jQuery));
